<div class="ticket-detail-parent-card">
  <div class="header">
    <div class="left">
      <img
        src="../../../../../../../assets/images/icons/icon_subdirectory_arrow_right.svg"
        alt="icon subdirectory arrow right"
      />
      <span class="header--title">Parent Ticket</span>
    </div>
  </div>
  @if (isLoadingParentTicket) {
    <div class="body">
      <div class="body--title">
        <ngx-skeleton-loader
          [theme]="{ width: '100px', height: '16px', background: 'var(--background-input-v2)' }"
        ></ngx-skeleton-loader>
      </div>
      <div class="body--status">
        <ngx-skeleton-loader
          [theme]="{ width: '120px', height: '16px', background: 'var(--background-input-v2)' }"
        ></ngx-skeleton-loader>
      </div>
      <div class="body--description">
        <ngx-skeleton-loader
          [theme]="{ width: '75%', height: '16px', background: 'var(--background-input-v2)' }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          [theme]="{ width: '60%', height: '16px', background: 'var(--background-input-v2)' }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  } @else {
    <!-- Error state for parent ticket -->
    @if (apiParentTicketFailed) {
      <div class="error-state">
        <img src="../../../../../../../assets/images/icons/icon-error-parent.svg" />
        <p>There was an error retrieving parent ticket.</p>
        <p>Please try again</p>
        <button mat-stroked-button color="primary" (click)="retryFetchParentTicket()">Retry</button>
      </div>
    }
    @if (!apiParentTicketFailed) {
      <div
        class="body"
        [routerLink]="['/secured/managed-services/tickets', parentTicketData.id]"
        style="cursor: pointer"
      >
        <div class="body--title">
          <span>{{ parentTicketData.id }}</span>
        </div>
        <div class="body--status" [style.background-color]="mspStatusData?.colorProfile.backgroundColor">
          <div class="circle-indicator" [style.background-color]="mspStatusData?.colorProfile.foregroundColor"></div>
          <span>{{ mspStatusData?.hubStatus ?? parentTicketData.statusName }}</span>
        </div>
        <div class="body--description">
          <span>{{ parentTicketData.summary }}</span>
        </div>
      </div>
    }
  }
</div>
